import {Dropdown, Form, FormGroup} from "semantic-ui-react";
import styles from "../../DataInspector/DataInspector.module.css";
import React, {useEffect, useState} from "react";
import {equipmentService} from "../../../services/equipmentService";
import {dataInspectorService} from "../../../services/DataInspectorService";
import {useReport} from "../../../providers/ReportProvider";

export const EquipmentReportForm = ({equipmentId, onSubmit}) => {
    const today = new Date();

    //form fields
    const [reportStartDate, setReportStartDate] = useState(`${today.getFullYear()}-01-01`);
    const [reportEndDate, setReportEndDate] = useState(`${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, "0")}-${today.getDate().toString().padStart(2, "0")}`);
    const [benchmarkStartDate, setBenchmarkStartDate] = useState(`${today.getFullYear() - 1}-01-01`);
    const [benchmarkEndDate, setBenchmarkEndDate] = useState(`${today.getFullYear() - 1}-12-31`);
    const [blendedElectricRate, setBlendedElectricRate] = useState(0.07);
    const [blendedThermalRate, setBlendedThermalRate] = useState(5.60);
    const [blendedThermalUnit, setBlendedThermalUnit] = useState('MCF');
    const [comparisonType, setComparisonType] = useState('temp');
    const [templateId, setTemplateId] = useState(1);

    //options
    const [benchmarkMetricOptions, setBenchmarkMetricOptions] = useState([]);
    const [idealMetricOptions, setIdealMetricOptions] = useState([]);
    const [pointMetricOptions, setPointMetricOptions] = useState([]);

    //selections
    const [selectedBenchmarkMetrics, setSelectedBenchmarkMetrics] = useState([]);
    const [selectedIdealMetrics, setSelectedIdealMetrics] = useState([]);
    const [selectedPointMetrics, setSelectedPointMetrics] = useState([]);

    const [errors] = useState();
    const [loading, setLoading] = useState(false);

    const {
        reportTemplate,
        getReportTemplate
    } = useReport();

    useEffect(() => {
        if (templateId) getReportTemplate(templateId);
    }, [getReportTemplate, templateId]);

    useEffect(() => {
        setBenchmarkMetricOptions(reportTemplate.benchmarkMetrics?.map(metric => ({
            key: metric.id,
            value: metric.id,
            text: metric.name,
            code: metric.name
        })));

        setIdealMetricOptions(reportTemplate.idealMetrics?.map(metric => ({
            key: metric.id,
            value: metric.id,
            text: metric.name,
            code: metric.name
        })));

        setPointMetricOptions(reportTemplate.pointMetrics?.map(metric => ({
            key: metric.id,
            value: metric.id,
            text: metric.name,
            code: metric.name
        })));
    }, [reportTemplate]);

    const handleSelectedBenchmarkMetricChange = selectedItems => {
        if (selectedItems.length > 0) {
            const temp = [];
            selectedItems.forEach(function (dropdownKey) {
                let point = benchmarkMetricOptions?.find(x => x.key === dropdownKey);
                temp.push(point);
            });
            setSelectedBenchmarkMetrics(temp);
        } else {
            setSelectedBenchmarkMetrics([]);
        }
    };

    const handleSelectedIdealMetricChange = selectedItems => {
        if (selectedItems.length > 0) {
            const temp = [];
            selectedItems.forEach(function (dropdownKey) {
                let point = idealMetricOptions?.find(x => x.key === dropdownKey);
                temp.push(point);
            });
            setSelectedIdealMetrics(temp);
        } else {
            setSelectedIdealMetrics([]);
        }
    };

    const handleSelectedPointMetricChange = selectedItems => {
        if (selectedItems.length > 0) {
            const temp = [];
            selectedItems.forEach(function (dropdownKey) {
                let point = pointMetricOptions?.find(x => x.key === dropdownKey);
                temp.push(point);
            });
            setSelectedPointMetrics(temp);
        } else {
            setSelectedPointMetrics([]);
        }
    };

    const handleSubmit = async () => {
        setLoading(true);

        const formData = {
            equipmentId: equipmentId,
            templateId: templateId,
            comparisonType: comparisonType,
            reportStartDate: reportStartDate,
            reportEndDate: reportEndDate,
            benchmarkStartDate: benchmarkStartDate,
            benchmarkEndDate: benchmarkEndDate,
            blendedElectricRate: blendedElectricRate,
            blendedThermalRate: blendedThermalRate,
            idealMetrics: selectedIdealMetrics.map(metric => metric.key),
            benchmarkMetrics: selectedBenchmarkMetrics.map(metric => metric.key),
            pointMetrics: selectedPointMetrics.map(metric => metric.key)
        }

        onSubmit(formData);
        setLoading(false);
    }

    return (
        <Form onSubmit={handleSubmit} error={!!errors}>
            <Form.Group>
                <Form.Input
                    width={3}
                    className={styles.inspectorInput}
                    type={'date'}
                    defaultValue={reportStartDate}
                    label="Report Start Date"
                    placeholder="Time Range"
                    onChange={e => setReportStartDate(e.target.value)}
                />
                <Form.Input
                    width={3}
                    className={styles.inspectorInput}
                    type={'date'}
                    defaultValue={reportEndDate}
                    label="Report End Date"
                    placeholder="Time Range"
                    onChange={e => setReportEndDate(e.target.value)}
                />
                <div className={"three wide field"}>
                    <label>Benchmark Metrics</label>
                    <Dropdown
                        label="Benchmark Metrics"
                        placeholder="Benchmark Metrics"
                        options={benchmarkMetricOptions || []}
                        value={selectedBenchmarkMetrics.map(f => f.key)}
                        onChange={(e, {value}) => {
                            handleSelectedBenchmarkMetricChange(value);
                        }}
                        multiple
                        selection
                        search
                        clearable
                    />
                </div>
                <div className={"three wide field"}>
                    <label>Ideal Metrics</label>
                    <Dropdown
                        label="Ideal Metrics"
                        placeholder="Ideal Metrics"
                        options={idealMetricOptions || []}
                        value={selectedIdealMetrics.map(f => f.key)}
                        onChange={(e, {value}) => {
                            handleSelectedIdealMetricChange(value);
                        }}
                        multiple
                        selection
                        search
                        clearable
                    />
                </div>
                <div className={"three wide field"}>
                    <label>Point Metrics</label>
                    <Dropdown
                        label="Point Metrics"
                        placeholder="Point Metrics"
                        options={pointMetricOptions || []}
                        value={selectedPointMetrics.map(f => f.key)}
                        onChange={(e, {value}) => {
                            handleSelectedPointMetricChange(value);
                        }}
                        multiple
                        selection
                        search
                        clearable
                    />
                </div>
            </Form.Group>
            <Form.Group>
                <Form.Input
                    width={3}
                    className={styles.inspectorInput}
                    type={'date'}
                    defaultValue={benchmarkStartDate}
                    label="Benchmark Start Date"
                    placeholder="Time Range"
                    onChange={e => setBenchmarkStartDate(e.target.value)}
                />
                <Form.Input
                    width={3}
                    className={styles.inspectorInput}
                    type={'date'}
                    defaultValue={benchmarkEndDate}
                    label="Benchmark End Date"
                    placeholder="Time Range"
                    onChange={e => setBenchmarkEndDate(e.target.value)}
                />
            </Form.Group>
            <FormGroup>
                <Form.Input
                    width={3}
                    label="Blended Electric Rate ($/kWh)"
                    type={'number'}
                    value={blendedElectricRate}
                    step={0.01}
                    onChange={e => setBlendedElectricRate(e.target.value)}
                    required
                />
                <Form.Input
                    width={3}
                    label="Blended Thermal Rate ($/MCF)"
                    type={'number'}
                    value={blendedThermalRate}
                    step={0.01}
                    onChange={e => setBlendedThermalRate(e.target.value)}
                    required
                />
            </FormGroup>
            <FormGroup>
                <Form.Button size={'large'} loading={loading} color={'blue'}>
                    Submit
                </Form.Button>
            </FormGroup>
        </Form>
    );
}
